import { SET_MEDIA } from '../actions/types';

export default function media(
	state = {
		images: [],
		videoOrder: [],
		videos: {}
	},
	action
) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_MEDIA:
				return action.payload;
			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/media.js